import { render } from "./AccountAddressContent.vue?vue&type=template&id=8e676abe&scoped=true"
import script from "./AccountAddressContent.vue?vue&type=script&lang=js"
export * from "./AccountAddressContent.vue?vue&type=script&lang=js"

import "./AccountAddressContent.vue?vue&type=style&index=0&id=8e676abe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8e676abe"

export default script